import { NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';

import { FuseCardComponent } from '@fuse/components/card';
import { AuthService } from 'app/core/auth/auth.service';
import { ILead, IOrder, iDebitOrderMandate } from 'app/core/shared-services/shared-interface.types';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { SharedServiceService } from 'app/core/shared-services/shared-service.service';

import { MatDialog } from '@angular/material/dialog';
import { MandatePopupComponent } from 'app/modules/financials/debit-orders/mandate-popup/mandate-popup.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  standalone: true,
  selector: 'app-debit-orders',
  templateUrl: './debit-orders.component.html',
  styleUrls: ['./debit-orders.component.scss'],
  imports: [FuseCardComponent, MatStepperModule, MatIconModule, MatButtonModule, NgFor, NgIf, MandatePopupComponent],

})
export class DebitOrdersComponent implements OnInit {
  @Input() dealerCode: string;
  @Output() loadOrders = new EventEmitter();
  @Output() debitOrderMandateSigned = new EventEmitter();
  @Input() debitOrderMandate: iDebitOrderMandate;
  @Input() checkoutProcessView: boolean = false;
  @Input() lead: ILead;
  @Input() orderFromDashboard: IOrder;

  public debitOrderList: Array<iDebitOrderMandate>;
  public acceptedDebitOrder: iDebitOrderMandate;
  private debitOrderListResult: any;

  constructor(
    public _authService: AuthService,
    private _sharedMethods: SharedMethodsModule,
    public _sharedService: SharedServiceService,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute
  
  ) {
  }

  async ngOnInit() {


  }

  ngOnChanges() {
  }

  public debitOrderMandateAction(data) {
    this.dialog.open(MandatePopupComponent, {
      disableClose: true,
      width: '80vw',
      height: 'auto',
      backdropClass: 'blurModalBackground',
      panelClass: 'fuse-confirmation-dialog-panel',
      data: {
        mandateData: data,
        customerNumber: this.lead?.LeadContactNumber
      }
    }).afterClosed().subscribe(() => {
      if (this.checkoutProcessView) {
        this.getDebitOrder();
      } else {
        // RELOAD ORDERS ON DASHBOARD
        this.loadOrders.emit();
      }

    });
  }

  public async generateDebitOrderMandate(data: any) {
    await this._sharedMethods.getLeadById(data?.LeadEntityID).then(async (res: any) => {
      await this._sharedMethods.generateDebitOrderMandate(data?.LeadEntityID, res.AccountLinkedEntityID, res.ContractTotalRecurringIncl, this._sharedService.customerPaymentMethod).then((res: any) => {
        // ## LOAD THE IFRAME PDF WITH NEW DATA ##
        if (res.success) {
          // RELOAD ORDERS ON DASHBOARD
          this.loadOrders.emit();

        }
      });
    });
  }

  private async getDebitOrder(): Promise<void> {
    this.debitOrderListResult = await this._sharedMethods.getDebitOrder(this.lead?.LeadEntityID);
    if (this.debitOrderListResult.success) {
      this.debitOrderList = this.debitOrderListResult.result;
      this.debitOrderList.forEach((element: iDebitOrderMandate) => {
        if (element.Status === 'Accepted') {
          this.acceptedDebitOrder = element;
          this.debitOrderMandate = element;
          this.debitOrderMandateSigned.emit(true);
        }
      });
    }
  }

}
